import { Component, inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { RunningActions } from 'src/app/services/running-actions/running-actions.service';
import { EntityInterface, TableAction } from 'src/app/model/Table';

/**
 * Table actions encapsulates a list of actions that can be performed in a table cell
 * into the angular material button toggle group
 */
@Component({
    selector: 'app-table-actions',
    templateUrl: './table-actions.component.html',
    styleUrl: './table-actions.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TableActionsComponent<Entity extends EntityInterface> {
  private _runningActions = inject(RunningActions);

  /** A list of actions associated with the toggle group */
  @Input() actions!: TableAction<Entity>[];

  /** The associated model with the table row */
  @Input() entity!: Entity;

  public isDisabled(action: TableAction<Entity>) {
    return action.disable?.(this.entity) || this._runningActions.get(action, this.entity);
  }

  public isRunning(action: TableAction<Entity>) {
    // FIXME: workaround since API doesn't return a token upon creation
    if (!this.entity.id) { return false; }
    
    return this._runningActions.get(action, this.entity)
  }
}

